import { Box, Loader, Stack, Divider, Title } from '@mantine/core';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';
import { useStartRemoteDocsConnectionOAuthMutation } from 'src/secret-menu/sharepoint/hooks/useStartRemoteDocsConnectionOAuthMutation';
import { Button } from 'src/components';
import { OAuthPlatform } from 'src/secret-menu/sharepoint/types';
import { useRemoteDocsConnections } from 'src/secret-menu/sharepoint/hooks/useRemoteDocsConnections';
import SharepointDocs from 'src/secret-menu/sharepoint/SharepointDocs';

export default function SharepointTab() {
  const {
    latestActiveConnection,
    isLoading: isLoadingConnections,
    isError,
  } = useRemoteDocsConnections();
  const { startOAuth, isLoading: isStarting } = useStartRemoteDocsConnectionOAuthMutation();

  const handleStartAuth = async (platform: OAuthPlatform) => {
    try {
      const { url } = await startOAuth(platform);
      window.location.href = url;
    } catch (error) {
      notifyAndLogError('Failed to connect calendar', 'Please try again later.', error);
    }
  };

  if (isLoadingConnections) {
    return <Loader />;
  }

  if (isError) {
    return <div>Error loading connections</div>;
  }

  if (latestActiveConnection) {
    return (
      <Box p="md">
        <Stack gap="xl">
          <Box>
            <Title order={2} mb="md">
              SharePoint Integration
            </Title>
            <div>Connected to Sharepoint</div>
          </Box>

          <Divider />

          <Box>
            <Title order={3} mb="md">
              SharePoint Documents Browser
            </Title>
            <SharepointDocs />
          </Box>
        </Stack>
      </Box>
    );
  }

  return (
    <Box p="md">
      <Stack gap="xl">
        <Box>
          <Title order={2} mb="md">
            SharePoint Integration
          </Title>
          <Button onClick={async () => await handleStartAuth('MICROSOFT')} loading={isStarting}>
            Connect to sharepoint
          </Button>
        </Box>
      </Stack>
    </Box>
  );
}
